<template>
    <div>

        <textarea :placeholder="pb_placeholder_s"
                  class="TQ_width_100p TQ_borderBox TQ_font_SecularOne"
                  :class="pb_textareaClass_s"
                  type="text"
                  :ref="p_refName_s"
                  :rows="pb_rows_n"
                  :disabled="p_disable_b"
                  v-model="text_s"
                  @input="m_changeText_f">
        </textarea>


        <div v-if="pb_maxLength_n>0" class="TQ_textAlign_end TQ_text_14px lc_maxTextLength ">
            <span class="TQ_direction_ltr">{{text_s.length}}/{{pb_maxLength_n}}</span>
        </div>


    </div>
</template>

<script>

    export default {
        name: "TqTextarea",
        props:{
            pb_uid_s:{
                type: String,
                default: "TqTextarea"
            },
            pb_rows_n:{
                type: Number,
                default: 10
            },
            pb_maxLength_n:{
                type: Number,
                default: 0
            },
            pb_initText_s:{
                type: String,
                default: "",
            },
            pb_placeholder_s:{
                type: String,
                default: "",
            },
            p_disable_b:{
                type: Boolean,
                default: false
            },

            pe_changeText_s:{
                type: Function,
                require: true
            },

            pb_textareaClass_s:{
                type: String,
                default: "",
            },

            pf_autoresize_b : {
                type: Boolean,
                default: false,
            }


        },
        watch : {
            pb_initText_s :{
                handler(){
                    this.text_s = this.pb_initText_s;
                }
            }
        },
        data(){
            return {
                text_s : this.pb_initText_s,
            }
        },
        computed:{
            p_refName_s(){
                return 'ref_testarea_' + this.pb_uid_s
            }
        },
        methods:{
            m_watch_autosize_f(e){
                // let el = e.target
                let el = this.$refs[this.p_refName_s]

                setTimeout(() => {
                    el.style.cssText = 'height:auto; padding:0';
                    // for box-sizing other than "content-box" use:
                    // el.style.cssText = '-moz-box-sizing:content-box';
                    el.style.cssText = 'height:' + el.scrollHeight + 'px';
                },0);
            },
            m_changeText_f(){

                if(this.text_s.length > this.pb_maxLength_n){
                    this.text_s = this.text_s.substring(0, this.pb_maxLength_n)
                }

                if(this.pf_autoresize_b){
                    this.m_watch_autosize_f()
                }

                this.pe_changeText_s(this.text_s)
            }
        },




    }
</script>

<style scoped>
    .lc_maxTextLength{
        margin: -4px 4px 0;
    }
</style>